import * as types from './constants';

export const registerFieldChange = (field, value) => ({
  type: types.REGISTER_FIELD_CHANGE,
  field,
  value
});

export const selectChange = id => ({
  type: types.SELECT_CHANGE,
  id
});

export const setRestrictions = data => ({
  type: types.SET_RESTRICTIONS,
  data
});

export const handleLoading = status => ({
  type: types.HANDLE_LOADING,
  status
});

export const setRestrictionsErrors = errors => ({
  type: types.SET_RESTRICTIONS_ERRORS,
  errors
});

export const clearRestrictionsErrors = () => ({
  type: types.CLEAR_RESTRICTIONS_ERRORS
});

export const clearRestrictions = () => ({
  type: types.CLEAR_RESTRICTIONS
});